import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core'
import { Application } from 'src/app/account/services/application.service'
import { DetailedIssue } from 'src/app/account/services/issue'
import { SyncPair } from 'src/app/account/services/sync-pair.service'
import { UiService } from 'src/app/services/ui.service'
import { environment } from '../../../../../environments/environment'
import { ModalDialogComponent } from '../../../../shared/modal-dialog/modal-dialog.component'
import { ApplicationType } from '../../../../services/dtos'
import { CopyFeedbackService } from 'src/app/shared/copy-feedback.service'
import { TabConfig } from '../../../../shared/components/tabs/tabs.component'

@Component({
  selector: 'detailed-issue',
  templateUrl: './detailed-issue.component.html',
  styleUrls: ['./detailed-issue.component.scss'],
  standalone: false,
  providers: [CopyFeedbackService],
})
export class DetailedIssueComponent implements OnChanges {
  originalErrorHeaderText = 'Original Error'
  @Input() issue: DetailedIssue = null
  @Input('sync-pair') syncPair: SyncPair = null
  @Input('application') application: Application = null
  @ViewChild('updateAccessDialog', { static: true }) updateAccessDialog: ModalDialogComponent

  scriptLanguages: string[] = []
  scriptTabs: TabConfig[] = []
  activeScriptTabIndex = 0

  constructor(
    public uiService: UiService,
    public copyFeedback: CopyFeedbackService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['issue']) {
      const prev = changes['issue'].previousValue as DetailedIssue
      const curr = changes['issue'].currentValue as DetailedIssue
      const scriptsChanged = prev?.scripts !== curr?.scripts
      this.buildScriptTabs(scriptsChanged)
    }
  }

  private buildScriptTabs(resetIndex = true): void {
    if (this.issue?.scripts) {
      this.scriptLanguages = Object.keys(this.issue.scripts)
      this.scriptTabs = this.scriptLanguages.map((lang) => ({
        label: lang,
        route: lang,
      }))
      if (resetIndex) {
        this.activeScriptTabIndex = 0
      }
    } else {
      this.scriptLanguages = []
      this.scriptTabs = []
      this.activeScriptTabIndex = 0
    }
  }

  get activeScriptLanguage(): string {
    return this.scriptLanguages[this.activeScriptTabIndex] || null
  }

  get activeScriptContent(): string {
    if (!this.activeScriptLanguage || !this.issue?.scripts) return ''
    return this.issue.scripts[this.activeScriptLanguage]
  }

  onScriptTabChange(index: number): void {
    this.activeScriptTabIndex = index
    this.cdr.detectChanges()
  }

  get productName() {
    return environment.productName
  }

  get applicationType() {
    return this.application?.type || ApplicationType.AWS
  }

  get sourceEndpointUri() {
    return !!this.syncPair ? this.syncPair.sourceEndpointUri : this.application.sourceEndpointUri
  }

  get targetEndpointUri() {
    return !!this.syncPair ? this.syncPair.targetEndpointUri : this.application.targetEndpointUri
  }

  get identityProviderId() {
    return this.application?.identityProviderId || null
  }

  public showAccessDialog(event) {
    event.preventDefault()
    this.updateAccessDialog.open()
  }

  public dismissAccessDialog() {
    this.updateAccessDialog.close()
  }
}
